import { render, staticRenderFns } from "./Playvideo.vue?vue&type=template&id=6d0e14b8&"
import script from "./Playvideo.vue?vue&type=script&lang=js&"
export * from "./Playvideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports